module.exports = __webpack_public_path__ + "img/logo_meuspedidos.70453bc0.png";